var _path, _defs;
const _excluded = ["svgRef", "title"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import React from "react";
const SvgAudioStudioTab = _ref => {
  let {
      svgRef,
      title
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M15.9999 20.5714C19.5285 20.5714 22.3999 17.4949 22.3999 13.7143V6.85714C22.3999 3.07657 19.5285 0 15.9999 0C12.4714 0 9.59994 3.07657 9.59994 6.85714V13.7143C9.59994 17.4949 12.4714 20.5714 15.9999 20.5714ZM25.6 9.14296C25.0112 9.14296 24.5333 9.65268 24.5333 10.2858V13.7144C24.5333 18.7567 20.7061 22.8572 16 22.8572C11.2939 22.8572 7.46667 18.7567 7.46667 13.7144V10.2858C7.46667 9.65268 6.9888 9.14296 6.4 9.14296C5.8112 9.14296 5.33334 9.65268 5.33334 10.2858V13.7144C5.33334 19.623 9.55734 24.4435 14.9333 25.0264V29.3334H10.8148C10.0784 29.3334 9.48144 29.9304 9.48144 30.6667C9.48144 31.4031 10.0784 32.0001 10.8148 32.0001H15.9932C15.9955 32.0001 15.9977 32.0001 16 32.0001C16.0023 32.0001 16.0045 32.0001 16.0068 32.0001H21.4222C22.1586 32.0001 22.7555 31.4031 22.7555 30.6667C22.7555 29.9304 22.1586 29.3334 21.4222 29.3334H17.0667V25.0264C22.4427 24.4435 26.6667 19.623 26.6667 13.7144V10.2858C26.6667 9.65268 26.1888 9.14296 25.6 9.14296Z",
    fill: "var(--asset-gradient-id)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "audio-gradient-top",
    x1: 16,
    y1: 0,
    x2: 16,
    y2: 32,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "var(--asset-color)"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "var(--asset-bg-color)"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "audio-gradient-left",
    x1: 32,
    y1: 16,
    x2: 0,
    y2: 16,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "var(--asset-color)"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "var(--asset-bg-color)"
  })))));
};
const ForwardRef = /*#__PURE__*/React.forwardRef((props, ref) => /*#__PURE__*/React.createElement(SvgAudioStudioTab, _extends({
  svgRef: ref
}, props)));
export default __webpack_public_path__ + "static/media/audio-studio-tab.adad27b6.svg";
export { ForwardRef as ReactComponent };